<template>
  <div>
    <div>
      <van-swipe
        :autoplay="3000"
        indicator-color="white"
        style="width: 100%; height: 4rem"
      >
        <van-swipe-item v-for="(image, index) in images" :key="index">
          <img :src="image.url" style="width: 100%; height: 100%" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <div>
      <div class="index_market_box">
        <div class="index_market">
          <div
            class="index_4tu"
            v-for="item in navigation"
            :key="item.id"
            @click="toSystem(item.id)"
          >
            <img class="index_4tu_img" :src="item.imgurl" />
            <span class="index_4tu_title">{{ item.title }}</span>
          </div>
        </div>
      </div>
      <!-- 选择论文检测系统 -->
      <section>
        <div class="application_hall">
          <div class="application_title">万方查重论文检测系统</div>
          <div class="title_down_line"></div>
          <div class="application_desc size-24 color-666"></div>
          <!-- 内容 -->
          <div class="application_cont">
            <div
              class="application_item"
              v-for="list in system"
              :key="list.name"
              @click="toCheck(list)"
            >
              <img class="application_img" :src="list.url" />
              <h2 class="size-30 color-333">{{ list.name }}</h2>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div class="index_process">
          <div class="text-center">万方查重流程</div>
          <div class="title_down_line"></div>
          <div class="index_process_list">
            <div
              class="index_process_item"
              v-for="data in explain"
              :key="data.nember"
            >
              <div class="index_process_left">{{ data.number }}</div>
              <span class="size-28 color-666">{{ data.content }}</span>
            </div>
          </div>
          <div>
            <p
              style="
                font-size: 0.3rem;
                color: #666;
                text-align: center;
                margin-bottom: 0.3rem;
              "
            >
              深圳智汇教育有限公司
            </p>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";
import { getAllCategories, getCategoryPrice } from "@/utils/order";
export default {
  data() {
    return {
      images: [
        {
          id: 1,
          url: require("../assets/img/banner1.jpg"),
        },
        {
          id: 2,
          url: require("../assets/img/banner2.jpg"),
        },
        {
          id: 3,
          url: require("../assets/img/banner3.jpg"),
        },
      ],
      navigation: [
        {
          id: 0,
          imgurl: require("../assets/img/servicea.png"),
          title: "系统介绍",
        },
        {
          id: 1,
          imgurl: require("../assets/img/serviceb.png"),
          title: "常见问题",
        },
        {
          id: 2,
          imgurl: require("../assets/img/icon_8.png"),
          title: "开始查重",
        },
        {
          id: 3,
          imgurl: require("../assets/img/serviced.png"),
          title: "下载报告",
        },
      ],
      explain: [
        {
          number: 1,
          content: "选择要使用的论文检测系统",
        },
        {
          number: 2,
          content: "上传待检测的论文",
        },
        {
          number: 3,
          content: "支付相应价格后等待检测完成通知",
        },
        {
          number: 4,
          content: "查看论文检测报告",
        },
      ],
      system: [],
      id: "",
      banben: "",
      price: "",
      pricetype: "",
      desc: "",
      cid: "",
      uservalue: "",
    };
  },
  created() {
    this.loadCategories();
  },
  methods: {
    loadCategories() {
      this.$http.getjcList().then((res) => {
        this.system = getAllCategories(res).map((item) => ({
          ...item,
          url: item.sys_logo,
        }));
      });
    },
    toSystem(item) {
      switch (item) {
        case 0:
          this.$router.push("/introduce");
          break;
        case 1:
          this.$router.push("/matter");
          break;
        case 2:
          this.$router.push("/jcsystem");
          break;
        case 3:
          this.$router.push("/report");
          break;
        default:
          break;
      }
    },
 toCheck(category) {
  if (window.sessionStorage.getItem("Token")) {
    let storageData = JSON.parse(window.sessionStorage.getItem("user"));
    if (storageData) {
      this.uservalue = storageData.user_group;
    }
    this.id = category.id;
    this.banben = category.name;
    this.price = getCategoryPrice(category, this.uservalue);
    this.pricetype = category.price_type;
    this.desc = category.intro || category.sintro || "";
    this.cid = category.cid;
    this.$router.push({
      path: "/ccpage",
      query: {
        id: this.id,
        banben: this.banben,
        price: this.price,
        pricetype: this.pricetype,
        desc: this.desc,
        cid: this.cid,
        vip_price: category.vip_price || "",
      },
    });
  } else {
    // 自定义弹窗
    Dialog({
      title: "",
      message: `<div style="text-align: center; position: relative; max-height: 80vh; overflow: hidden; white-space: normal;"><div id="closeDialogBtn" style="position: absolute; top: 0px; right: 0px; cursor: pointer; font-size: 20px; color: #999; width: 26px; height: 26px; display: flex; align-items: center; justify-content: center; z-index: 10;">×</div><div style="margin-bottom: 12px;"><img src="${require("../assets/img/logo.jpg")}" alt="Logo" style="width: 100px; height: 100px; border-radius: 50%; object-fit: cover; border: 2px solid #f0f0f0;"></div><div style="margin-bottom: 18px; font-size: 16px; line-height: 1.5; color: #333; text-align: left;">因浏览器限制,无法查看论文检测进度;<br>为方便查收检测报告,请在微信小程序内提交。</div><div style="display: flex; flex-direction: column; gap: 10px; align-items: center;"><button id="openMiniProgramBtn" style="width: 200px; height: 40px; background: #07c160; color: white; border: none; border-radius: 20px; font-size: 16px; cursor: pointer; box-shadow: 0 2px 6px rgba(7, 193, 96, 0.3);">打开微信小程序</button><button id="continueLoginBtn" style="width: 200px; height: 40px; background: #eee; color: #999; border: 1px solid #ddd; border-radius: 20px; font-size: 16px; cursor: pointer;">继续网页登录</button></div></div>`,
      width: "85%",
      allowHtml: true,
      showConfirmButton: false,
      showCancelButton: false,
      closeOnClickOverlay: true,
    });

    // 绑定按钮事件
    setTimeout(() => {
      // 关闭按钮
      const closeBtn = document.getElementById('closeDialogBtn');
      if (closeBtn) {
        closeBtn.onclick = () => {
          Dialog.close();
        };
      }

      // 打开小程序按钮
      const openBtn = document.getElementById('openMiniProgramBtn');
      if (openBtn) {
        openBtn.onclick = () => {
          try {
            window.location.href = "weixin://dl/business/?appid=wx346def384ee887a2&path=pages/index/index&query=wxfrom=baidu";
            Dialog.close();
          } catch (error) {
            console.log("无法打开微信小程序:", error);
            Dialog.close();
            Dialog.alert({
              title: "提示",
              message: "请在微信搜一搜'万方论文检测'使用小程序"
            });
          }
        };
      }

      // 继续登录按钮
      const loginBtn = document.getElementById('continueLoginBtn');
      if (loginBtn) {
        loginBtn.onclick = () => {
          Dialog.close();
          const ua = window.navigator.userAgent.toLowerCase();
          if (ua.match(/MicroMessenger/i) == "micromessenger") {
            this.$router.push({
              path: "/blankpage",
              query: {
                currentpath: "/",
              },
            });
          } else {
            this.$router.push("/Login");
          }
        };
      }
    }, 100);
  }
},
  },
};
</script>

<style scoped>
.index_market_box {
  display: flex;
  flex-direction: column;
  padding: 0.2rem 0;
  background-color: #fff;
}
.index_4tu_title {
  font-size: 13px;
  margin-top: 0.3rem;
}
.index_4tu {
  display: flex;
  flex-direction: column;
  width: 25%;
  box-sizing: border-box;
}
.index_4tu_img {
  width: 1.2rem;
  height: 1.2rem;
  margin: auto;
}
.index_market {
  display: -webkit-flex;
  -webkit-flex-direction: row;
  -webkit-flex-wrap: wrap;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0 0.3rem;
  text-align: center;
  margin-top: 0.1rem;
}
section {
  margin-top: 0.2rem;
  background-color: #fff;
}
.index_process {
  overflow: hidden;
}
.index_process_list {
  position: relative;
  display: -webkit-flex;
  -webkit-flex-direction: column;
  display: flex;
  flex-direction: column;
  margin-left: 1.1rem;
  margin-top: 0.6rem;
  margin-bottom: 0.9rem;
}
.index_process_list:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0.3rem;
  height: 100%;
  background: #d7e4ed;
  border-left: 1px dashed #36bb81;
  z-index: -1;
}
.index_process_item {
  display: -webkit-flex;
  -webkit-flex-direction: row;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0.33rem 0;
}
.index_process_left {
  width: 0.6rem;
  height: 0.6rem;
  background: url("../assets/img/index_oval.png");
  background-size: 100%;
  background-position: center center;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -o-border-radius: 50%;
  border-radius: 50%;
  line-height: 0.6rem;
  text-align: center;
  font-size: 0.3rem;
  color: #fff;
  margin-right: 0.25rem;
}
.text-center {
  text-align: center;
  font-size: 0.4rem;
  color: #333333;
  margin-top: 0.7rem;
}
.size-28 {
  font-size: 0.28rem;
}
.color-666 {
  color: #666666;
}
/*应用大厅*/
.application_title {
  text-align: center;
  font-size: 0.4rem;
  color: #333333;
}
.application_hall {
  padding: 0.3rem 0.1rem;
  background: #f8f8f8;
}
.application_cont {
  display: -webkit-flex;
  -webkit-flex-direction: row;
  -webkit-flex-wrap: wrap;
  display: flex;
  justify-content: space-around;
  flex-direction: row;
  flex-wrap: wrap;
  text-align: center;
  margin-top: 0.2rem;
  margin-bottom: 0.3rem;
}
.application_item {
  display: -webkit-flex;
  -webkit-flex-direction: column;
  display: flex;
  flex-direction: column;
  width: 47%;
  box-sizing: border-box;
  -moz-box-sizing: border-box; /* Firefox */
  -webkit-box-sizing: border-box; /* Safari */
}
.application_item h2 {
  margin: 10px 0;
}
.application_img {
  height: 1.7rem;
  border: solid #ddd 1px;
}
.application_cont a.application_item:nth-child(even) {
  padding: 0.2rem 0.2rem 0 0.25rem;
}
.application_cont a.application_item:nth-child(odd) {
  padding: 0.2rem 0.25rem 0 0.2rem;
}
.title_down_line {
  width: 0.66rem;
  height: 2px;
  background: #333;
  margin: auto;
  margin-top: 0.25rem;
}
</style>
